import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class UserDTO  {
    _originalTypeClassName = "MidApp.BO.UserDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
UserDTO.translate = translateService;
}
this.username = null;
this.name = null;
this.phone = null;
this.email = null;
this.city = null;
this.gender = null;
this.firstName = null;
this.UserDTOKey = null;
this._key = this.UserDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
username:any;
name:any;
phone:any;
email:any;
city:any;
gender:any;
firstName:any;
private _UserDTOKey:any;
get UserDTOKey(): any {
    return this._UserDTOKey;
  }
set UserDTOKey(value: any) {
    this._UserDTOKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.UserDTOKey == null || $this.UserDTOKey == 0;
            }


}